// ─── Template Schema Types ───────────────────────────────────────────────────
export const OPERATOR_LABELS = {
    equals: 'Equals',
    not_equals: 'Not Equals',
    greater_than: 'Greater Than',
    less_than: 'Less Than',
    greater_than_or_equal: 'Greater Than or Equal',
    less_than_or_equal: 'Less Than or Equal',
    exists: 'Exists',
    not_exists: 'Not Exists',
    is_empty: 'Is Empty',
    is_not_empty: 'Is Not Empty',
    contains: 'Contains',
    does_not_contain: 'Does Not Contain',
};
export const VALUE_OPERATORS = [
    'equals',
    'not_equals',
    'greater_than',
    'less_than',
    'greater_than_or_equal',
    'less_than_or_equal',
    'contains',
    'does_not_contain',
];
export const DEFAULT_PAGE_SETTINGS = {
    lineSpacing: 1.5,
    afterLineSpacing: 1,
    topMargin: 2.25,
    bottomMargin: 1.25,
    leftMargin: 1.5,
    rightMargin: 1.5,
    headerDistance: 0.25,
    footerDistance: 0.25,
    fontSize: 10,
    fontFamily: 'Times New Roman',
};
